module.exports = __webpack_public_path__ + "media/images/story_ogp_image/episode_publication-3d05b0413c4ccb9ae70c069518367ffd.png";